
/* injects from baggage-loader */

'use strict';

import tabBookTpl from './tab-book.html';
import tabBookController from './tab-book.controller';

export default class tabBookComponent {
    constructor() {
        this.templateUrl = tabBookTpl;
        this.controller = tabBookController;
        this.bindings = {
            region: "@",
            model: "="
        };
    }
}


// WEBPACK FOOTER //
// ./src/app/components/ui/tab-book/tab-book.component.js